import { render, staticRenderFns } from "./Roleman.vue?vue&type=template&id=7cb47b59&scoped=true&"
import script from "./Roleman.vue?vue&type=script&lang=js&"
export * from "./Roleman.vue?vue&type=script&lang=js&"
import style0 from "./Roleman.vue?vue&type=style&index=0&id=7cb47b59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb47b59",
  null
  
)

export default component.exports